module.exports = __webpack_public_path__ + "static/img/unnka_yokobai.2d56164.jpg";